import { useCallback } from "react";
import {
  assignTicket,
  bulkAssignTickets,
  bulkSoftDeleteTickets,
  createBulkTickets,
  createTicket,
  getTeamProgress,
  listTickets,
  listTicketsV2,
  refreshTicketOutstanding,
  unassignTicket,
  updateTicketStatus,
  updateTicketStatusSelf,
  uploadBulkTickets,
} from "../service/CallCenterTickets";
import { useAsyncAction } from "./useAsyncAction";

export const useTickets = () => {
  const state = useAsyncAction([]);

  const list = useCallback(
    async (params) => state.run(() => listTicketsV2(params)),
    [state]
  );
  const listLegacy = useCallback(
    async (params) => state.run(() => listTickets(params)),
    [state]
  );
  const create = useCallback(
    async (payload) => state.run(() => createTicket(payload)),
    [state]
  );
  const createBulk = useCallback(
    async (payload) => state.run(() => createBulkTickets(payload)),
    [state]
  );
  const uploadBulk = useCallback(
    async (payload) => state.run(() => uploadBulkTickets(payload)),
    [state]
  );
  const bulkSoftDelete = useCallback(
    async (payload) => state.run(() => bulkSoftDeleteTickets(payload)),
    [state]
  );
  const assign = useCallback(
    async (payload) => state.run(() => assignTicket(payload)),
    [state]
  );
  const unassign = useCallback(
    async (payload) => state.run(() => unassignTicket(payload)),
    [state]
  );
  const bulkAssign = useCallback(
    async (payload) => state.run(() => bulkAssignTickets(payload)),
    [state]
  );
  const patchStatus = useCallback(
    async (payload) => state.run(() => updateTicketStatus(payload)),
    [state]
  );
  const patchStatusSelf = useCallback(
    async (payload) => state.run(() => updateTicketStatusSelf(payload)),
    [state]
  );
  const refreshOutstanding = useCallback(
    async (payload) => state.run(() => refreshTicketOutstanding(payload)),
    [state]
  );
  const teamProgress = useCallback(async () => state.run(() => getTeamProgress()), [state]);

  return {
    ...state,
    list,
    listLegacy,
    create,
    createBulk,
    uploadBulk,
    bulkSoftDelete,
    assign,
    unassign,
    bulkAssign,
    patchStatus,
    patchStatusSelf,
    refreshOutstanding,
    teamProgress,
  };
};
